import { useNavigate } from "react-router-dom";

const ACCOUNT_ROUTE = "/userinfo";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-[#212529] px-4">
      <div className="text-center">
        <i className="fa-solid fa-circle-xmark text-red-400 text-5xl mb-4" />
        <h1 className="text-2xl font-semibold">Payment Cancelled</h1>
        <p className="text-gray-500 mt-2">
          You cancelled the payment. No charges were made.
        </p>

        <button
          className="mt-6 px-6 py-2 bg-[#f4833d] text-white rounded hover:bg-[#e06a21] transition-all"
          onClick={() => navigate(ACCOUNT_ROUTE)}
        >
          Go to Account
        </button>
      </div>
    </div>
  );
};

export default PaymentCancel;